import style from "./post.module.scss";
import React from "react";

export function HrLine() {
  return <hr className={style.hr} />;
}
